import { Component, OnInit, Input } from '@angular/core'
import {CasoTareaModel, CasoTareaService} from 'src/app/services/casos_tareas.service'
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DeteccionFraudesComentarioComponent } from '../comentario/comentario.component'
import {NotificacionService} from 'src/app/services/notificaciones.service';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'deteccion-fraudes-boton-solicitar-revision',
  templateUrl: './boton-solicitar-revision.component.html',
  styleUrls: ['./boton-solicitar-revision.component.scss']
})
export class DeteccionFraudesBotonSolicitarRevisionComponent implements OnInit {

  @Input('caso') caso: CasoTareaModel
  @Input('cantidad_tareas_en_ejecucion') cantidad_tareas_en_ejecucion: number
  @Input('cantidad_tareas_en_pendiente') cantidad_tareas_en_pendiente: number
  @Input('permisos') permisos: string

  constructor(
    public dialog: MatDialog,
    public _notificaciones: NotificacionService,
    public _casos: CasoTareaService,
    public router: Router,
    public _snackbar: MatSnackBar
  ){}
  ngOnInit(){}

  async solicitarAprobacion(){
    let comentario = await this.abrirModalComentario()
    if(comentario){
      this.moverCasoaBloqueado(comentario)
      this.enviarNotificacionGerente()
      this.volverTodosLosCasos()
    }
  }

  async abrirModalComentario(){
    const dialogRef = this.dialog.open(DeteccionFraudesComentarioComponent, {width: "400px"});
    const comentario: string = await dialogRef.afterClosed().toPromise()
    return comentario
  }

  async moverCasoaBloqueado(comentario: string){
    this.caso.comentRevision = comentario
    this.caso.aprobacion = true
    this.caso.estado = 'Bloqueado'
    await this._casos.put(this.caso._id, this.caso).toPromise()
  }

  async enviarNotificacionGerente(){
    console.log("Enviando notificacion al gerente")
    const response = await this._notificaciones.notificacionDeteccionFraudesSolicitarRevisionSupervisor(this.caso.numero_caso).toPromise()
    console.log("Gerente informado",response)
  }

  async volverTodosLosCasos(){
    this.router.navigate(['casos/home/fraudes']);
  }

}
